module.exports = __webpack_public_path__ + "static/media/001.ff1aa734.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/Components/Carousel/CarouselMedia/001.jpg
// module id = 161
// module chunks = 0